module.exports = __webpack_public_path__ + "img/icon_acc_tx-history.62062acb.svg";